import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";

interface Props {
    icon: IconProp; // Only font awesome solid icons are supported at the moment
    className?: string;
    color?: string;
    title?: string;
    size?: SizeProp;
    id?: string;
    mode?: "button" | "icon";
    onClick?: () => void;
}

export default function SapIcon({ icon, className, color, title, size, id, onClick, mode }: Props) {
    return (
        <span title={title} style={{ cursor: mode === "button" ? "pointer" : "auto" }}>
            <FontAwesomeIcon id={id} className={className} icon={icon} color={color} size={size} onClick={onClick} />
        </span>
    );
}
